import React, { useState, useEffect } from 'react';
import './styles.css';

const MobileSkills = ({ isDarkMode }) => {
    const [skillsData, setSkillsData] = useState({});

    useEffect(() => {
        fetch('/data/skills.json')
            .then(response => response.json())
            .then(data => setSkillsData(data))
            .catch(error => console.error('Error fetching skills data:', error));
    }, []);

    return (
        <div className="mobile-page">
            <div className="mobile-content-wrapper">
                <div className="mobile-page-header">
                    <h1 className="mobile-page-header-title">Skills</h1>
                    <div className="mobile-page-header-accent"></div>
                </div>

                <div className="mobile-content-section">
                    {Object.entries(skillsData).map(([category, skills], index) => (
                        <div key={index} className="mobile-card">
                            <h3 className="mobile-card-title">{category}</h3>
                            <div className="mobile-skills-grid">
                                {skills.map((skill, skillIndex) => (
                                    <div key={skillIndex} className="mobile-skill-item">
                                        <span className="mobile-skill-name">{skill}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MobileSkills;
